import React from 'react'

const AgenciasInfo = () => {
  return (
    <div className={`containerWrap`}>
      <div className='tw-mb-6 tw-mb-8@lg center'>
        <h3 className='font-family-secondary c-gray--4 fw-4 fw-7@lg tw-f-20 tw-f-24@lg'>
          Agencias a nivel nacional
        </h3>
      </div>

      <div className='tw-mb-6 tw-mb-8@lg center'>
        <p className='font-family-primary c-gray--4 fw-4 tw-f-16 tw-f-16@lg'>
          A continuación la lista de agencias a nivel nacional con atención al público. La atención es con previa cita llamando a Fono Prima Lima: (01) 615-7272 Provincia: 0-801-18010. El horario de atención es de lunes a viernes de 9 a.m. a 5 p.m.
        </p>
      </div>

      <div className='w-100 flex justify-center'>
        <div className='table-0 w-100 w-70@lg'>
          <table className='w-100'>
            <thead className='bg-orange-4'>
              <tr>
                <th className='w-30 w-40@lg tw-f-14 tw-f-16@lg tw-p-4 tw-pr-0 tw-pl-9@lg tw-p-9@lg tw-py-7@lg left'>
                  Agencia
                </th>
                <th className='w-70 w-60@lg tw-f-14 tw-f-16@lg tw-p-4 tw-pl-0 tw-pr-9@lg tw-p-9@lg tw-py-7@lg right'>
                  Dirección
                </th>
              </tr>
            </thead>

            <tbody className='tw-f-14 tw-f-16@lg'>
              <tr>
                <td className='tw-py-5 tw-pl-9@lg'>San Isidro</td>
                <td className='tw-py-5 tw-pr-9@lg right'>CI. Chinchón 980</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className='tw-mt-6 tw-mt-8@lg center'>
        <h3 className='font-family-secondary c-gray--4 fw-4 fw-7@lg tw-f-20 tw-f-24@lg'>
          Atención Preferente
        </h3>
      </div>

      <div className='tw-mt-6 tw-mt-8@lg center'>
        <p className='font-family-primary c-gray--4 fw-4 tw-f-16 tw-f-16@lg'>
          Contamos con un servicio de atención preferente e inmediata para las mujeres embarazadas, niños, adultos mayores y personas discapacitadas, en todos nuestros Centros de Servicio al Cliente a nivel nacional, donde encontrarás publicado en lugar visible la Ley N°28683, referida a atención preferente.
        </p>
      </div>
    </div>
  )
};

export default AgenciasInfo;
